import {connect} from '../../app/connect';
import TemplateCreateModal from './TemplateCreateModal';
import {getCurrentProject, getAnalyticsId} from '../../app/selectors';
import {showNotificationAction, resetTemplatesHighlightingRowsAction} from '../../app/actions';

const mapStateToProps = state => ({
  currentProject: getCurrentProject(state),
  analyticsId: getAnalyticsId(state)
});

const mapDispatchToProps = {
  showNotificationAction,
  resetTemplatesHighlightingRowsAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCreateModal);
